module.exports = __webpack_public_path__ + "static/media/airbnb_lime.60f608cc.csv";